import { render, staticRenderFns } from "./IronsBannerMain.vue?vue&type=template&id=cdedcf08&scoped=true&"
import script from "./IronsBannerMain.vue?vue&type=script&lang=js&"
export * from "./IronsBannerMain.vue?vue&type=script&lang=js&"
import style0 from "./IronsBannerMain.vue?vue&type=style&index=0&id=cdedcf08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdedcf08",
  null
  
)

export default component.exports